// SyQi screen help (the "?" in the toolbar of the SyQi chat). Plain words; keep it in
// step with the screen in tools/SyqiTool.tsx.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const syqiHelp: ScreenHelpContent = {
  title: 'SyQi',
  intro:
    'SyQi is your guide to the whole app. This screen is a chat with her: ask a question in your own words and she answers. She remembers things you tell her and keeps your past chats.',
  sections: [
    {
      heading: 'Chatting',
      body: [
        'Type into "Message SyQi" and press Send (or the send key on your keyboard). Your message appears on the right in gold. SyQi\'s answer appears on the left. While she works you see "SyQi is thinking…".',
        'On a new chat you also see three quick questions you can tap instead of typing: "What should I focus on?", "Show me my progress" and "Give me today’s principle".',
        'If something goes wrong, the reply shows up with a red outline and the reason.',
      ],
    },
    {
      heading: 'The three buttons at the top',
      items: [
        { term: 'History', text: 'opens the list of your past chats. Search them by title, tap one to carry on with it, or press + New Chat.' },
        { term: '+ New', text: 'clears the screen and starts a fresh chat. Your old chat stays in History.' },
        { term: 'Memories', text: 'opens "SyQi\'s Memory": the things she has remembered about you, each with a category and a date.' },
      ],
    },
    {
      heading: 'History',
      body: [
        'Each chat shows its title and when it was last used (Today, Yesterday, a number of days ago, or a date). The chat you are in is highlighted.',
        'To delete a chat, press Delete on it, or press and hold it. You are asked to confirm, because deleting a chat removes all its messages for good.',
      ],
    },
    {
      heading: 'Memories',
      body: [
        'SyQi saves important things from your chats on her own, so you don\'t have to repeat yourself. Until she has saved something, the list says so.',
        'To make her forget one, press Delete next to it and confirm. This removes it for good.',
      ],
    },
    {
      heading: 'What is kept',
      body: [
        'There is no Save button. Chats are saved as you go. When you come back to this screen, SyQi opens the chat you were last in. Press + New to start over.',
      ],
    },
  ],
};
